import React from 'react';
import { connect } from 'react-redux';
import { hasHover, currentPage } from './actions';
import iPhone from '../assets/img/iPhone-6S.png';
import { Link } from 'react-router';
import MenuBar from './MenuBar';
import BottomNav from './BottomNav';


class MobileWrapper extends React.Component {

	componentDidMount() {
		const { hasHover, currentPage } = this.props.gui;
		this.setHoverClass(hasHover);
	  this.setCurrentPage(currentPage);
	}

	setHoverClass(hasHover) {
		if (!hasHover) {
			const _this = this;
			window.addEventListener('mouseover', function onFirstHover() {
	      _this.props.hasHover();
	      document.body.className += " hover"
	      window.removeEventListener('mouseover', onFirstHover, false);
	    });
	  }
	}

	setCurrentPage(currentPage) {
		if (!currentPage) {
	  	const pageFromPath = this.props.pathname.split('/')[1];
	  	this.props.currentPage(pageFromPath);
	  }
	}

	render() {
		return (
			<div className="body-wrapper">
				<div className="home-button"
					onClick={() => this.reload()}>
				</div>
				<img className="iphone" src={iPhone} alt="iPhone Frame"/>
				<div className="iphone__screen">
					{this.props.topNav !== false &&
						<MenuBar back={this.props.back} />
					}
					<div className="content">							
						{this.props.children}
					</div>
				</div>
			  <BottomNav
			  	currentPage={this.props.gui.currentPage}
			  	setCurrentPage={(name) => this.props.currentPage(name)} />
				<Link to="/">
				<div className="home-button"
					/>
				</Link>
			</div>
		);
	}
}

MobileWrapper.defaultProps = {
  children: null,
};

const mapStateToProps = state => ({
	gui: state.gui,
	all: state,
	pathname: state.routing.locationBeforeTransitions.pathname,

});

const mapDispatchToProps = dispatch => ({
	hasHover() {
		const hasClassAlready = document.body.classList.contains('hover')
		if(hasClassAlready) {
			console.log('Add class')
			dispatch(hasHover());
		}
	},
	currentPage(name) {
		dispatch(currentPage(name));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileWrapper);



// WEBPACK FOOTER //
// ./src/gui/MobileWrapper.js